import { Link } from "react-router-dom";
import { useContent } from "@/lib/useContent";

export default function Footer() {
  const { content } = useContent();
  const { site } = content;
  return (
    <footer data-testid="site-footer" className="border-t border-[#2C2C2C] bg-[#080808]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 md:col-span-6">
            <div className="font-display text-6xl md:text-8xl tracking-tighter leading-none">
              {site.name}<span className="text-[#C67022]">.</span>
            </div>
            <p className="mt-6 max-w-md text-white/50 font-light">
              {site.tagline} A quiet catalog of what he does when the cameras are off.
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">Chapters</div>
            <ul className="space-y-2 text-white/70">
              {content.chapters.map((c) => (
                <li key={c.id}>
                  <a href={`#${c.id}`} className="hover:text-[#C67022] transition-colors">
                    {c.number} · {c.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">Elsewhere</div>
            <ul className="space-y-2 text-white/70">
              <li><a href="#book" className="hover:text-[#C67022] transition-colors">Reserve →</a></li>
              <li><Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#C67022] transition-colors">Admin</Link></li>
              <li className="text-white/40 font-mono text-xs tracking-[0.25em] uppercase pt-2">{site.location}</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-[#2C2C2C] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-white/40">
          <div>© {site.years} · Trevor · All rights, most stories, reserved.</div>
          <div>Designed in low light.</div>
        </div>
      </div>
    </footer>
  );
}
